import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Inline current / compare-at price next to quantity on the buy-buttons block.
 * Updates when the selected variant changes (same section HTML as product form).
 */
class BuyButtonsInlinePrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const selector = blockId
      ? `buy-buttons-inline-price[data-block-id="${CSS.escape(blockId)}"]`
      : 'buy-buttons-inline-price';

    const newEl = event.detail.data.html.querySelector(selector);

    if (!newEl) return;

    morph(this, newEl, { childrenOnly: true });
  };
}

if (!customElements.get('buy-buttons-inline-price')) {
  customElements.define('buy-buttons-inline-price', BuyButtonsInlinePrice);
}
